import React from "react";
import LandingLeft from "./LandingLeft";
import LandingRight from "./LandingRight";
import "../App.css";
import Zoom from "react-reveal/Zoom";

const banner = {
  padding: "100px 0",
};

const Landing = () => {
  document.title = "DevJo React Appsite";
  return (
    <div className="ui" style={{ marginTop: "44px" }}>
      <div className="altColor">
        <Zoom>
          <h1 className="ui center aligned header" style={banner}>
            Welcome to DevJo Appsite
          </h1>
        </Zoom>
      </div>

      <div className="marginTopBtm">
        <LandingLeft
          image={require("../assets/img/ss1.png")}
          text={"GameGuard"}
          obj={{
            title: "GameGuard",
            desc: "A game that you do not want to lose out",
            dl: "Download to play and compete now!",
          }}
          links={{
            ios: "https://apps.apple.com/us/app/gameguard/id1501027282",
            android:
              "https://play.google.com/store/apps/details?id=io.devjo.gameguard",
          }}
          toWhere={"/gameguard"}
        />
      </div>

      <div className="altColor marginTopBtm">
        <LandingRight
          image={require("../assets/img/ss2.png")}
          text={"SpendGuard"}
          obj={{
            title: "SpendGuard",
            desc: "Need something to track your spending? Fret not, SpendGuard is here to help!",
            dl: "Download and get started with managing your expenses today.",
          }}
          links={{
            ios: "https://apps.apple.com/us/app/spendguard/id1482284888",
            android:
              "https://play.google.com/store/apps/details?id=io.devjo.expense",
          }}
          toWhere={"/spendguard"}
        />
      </div>

      <div className="marginTopBtm">
        <LandingLeft
          image={require("../assets/img/ss3.png")}
          text={"PasssGuard"}
          obj={{
            title: "PasssGuard",
            desc: "Need an secure app that keeps your credentials and to-do list?",
            dl: "Download and let the app manage for you!",
          }}
          links={{
            ios: "https://apps.apple.com/us/app/passsguard/id1458491688",
            android:
              "https://play.google.com/store/apps/details?id=io.ionic.password",
          }}
          toWhere={"/passsguard"}
        />
      </div>

      <div className="altColor marginTopBtm">
        <LandingRight
          image={require("../assets/img/ss4.png")}
          text={"CarparkSG"}
          obj={{
            title: "CarparkSG",
            desc: "Locate car park space before arriving destination. Here is what you need.",
            dl: "Download and start checking available parking lot before reaching your destination today!",
          }}
          links={{
            ios: "https://apps.apple.com/us/app/carparksg/id1460263050",
            android:
              "https://play.google.com/store/apps/details?id=cordova.devjo.carpark",
          }}
          toWhere={"/carpark"}
        />
      </div>

      <div className="marginTopBtm">
        <LandingLeft
          image={require("../assets/img/ss5.png")}
          text={"TransportGuard"}
          obj={{
            title: "Transport Guardian",
            desc: "Get bus arrival info and bus services details at your fingertip today!",
            dl: "Download and get started with your travelling journey today.",
          }}
          links={{
            ios: "https://apps.apple.com/app/id1593829504",
            android:
              "https://play.google.com/store/apps/details?id=io.devjo.transport",
          }}
          toWhere={"/transportguard"}
        />
      </div>
    </div>
  );
};

export default Landing;
